import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import api from '../api';
import { avisoMensalidade } from '../utils/avisoMensalidade';

const CHAVE = 'rfc_redirect_pelada_verificado';
// Só redireciona a partir das telas de entrada; links diretos (pagamento, avaliação...) são respeitados.
const ENTRADAS = ['/', '/painel'];

/**
 * Ao abrir a aplicação (uma vez por sessão do navegador), se houver pelada aberta,
 * leva o jogador logado direto para a Ordem de chegada — só depois que o aviso de
 * mensalidade em aberto for fechado (ou se não houver mensalidade em aberto).
 */
export function PeladaAtivaRedirect() {
  const { isAuthenticated, userLogado, token } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const jogador = isAuthenticated && userLogado && userLogado._id && !['Arbitro', 'Goleiro'].includes(userLogado.perfil);
    if (!jogador || !ENTRADAS.includes(pathname)) return;
    try {
      if (sessionStorage.getItem(CHAVE)) return;
      sessionStorage.setItem(CHAVE, '1');
    } catch (e) {
      // sem sessionStorage: verifica mesmo assim
    }
    // Token explícito: logo após o login ele ainda não foi gravado no localStorage que o `api` lê
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : undefined;
    const peladaAberta = api.get('getPeladaActive', config).then((response) => Boolean(response.data && response.data.data)).catch(() => false);
    Promise.all([peladaAberta, avisoMensalidade(userLogado._id, token).liberado]).then(([aberta]) => {
      // Só redireciona se o jogador continua na tela de entrada
      if (aberta && ENTRADAS.includes(window.location.pathname)) navigate('/ordem-chegada', { replace: true });
    });
  }, [isAuthenticated, userLogado, token, pathname, navigate]);

  return null;
}
